"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyProjectileAttackWithDamage = void 0;
function applyProjectileAttackWithDamage(args) {
    const { abilityKey, idleAfter, projectileType, projectilePath, startAtAttachment, endAtAttachment, attackType, attackerId, targetId, toApply, onBeforeDamage, onHit, onMiss, onHitOrMiss, originId = args.attackerId } = args;
    let { sequence } = args;
    const projectiles = Array.of({
        creatorId: originId,
        targetId,
        jitter: 0,
        path: projectilePath,
        type: projectileType,
        start: startAtAttachment,
        end: endAtAttachment,
    });
    this.applyAttack({
        type: attackType,
        attackerId,
        targetId,
        abilityKey,
        idleAfter,
        sequence,
        onBeforeDamage: (sequence) => {
            onBeforeDamage === null || onBeforeDamage === void 0 ? void 0 : onBeforeDamage(sequence);
        },
        onHit: (hitSequence, _, attack) => this.applyProjectiles({
            sequence: hitSequence,
            projectiles,
            onProjectile: (projectileSequence) => {
                const inner = projectileSequence.pushSequence("parallel");
                const { applied } = this.applyAttackDamages({
                    attackType,
                    attackerId,
                    targetId,
                    isCrit: attack.crit,
                    sequence: inner,
                    toApply
                });
                onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(inner, attack);
                onHit === null || onHit === void 0 ? void 0 : onHit(inner, attack, applied);
            }
        }),
        onMiss: (missSequence, _, attack) => this.applyProjectiles({
            sequence: missSequence,
            projectiles,
            onProjectile(projectileSequence) {
                onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(projectileSequence, attack);
                onMiss === null || onMiss === void 0 ? void 0 : onMiss(projectileSequence, attack);
            }
        })
    });
}
exports.applyProjectileAttackWithDamage = applyProjectileAttackWithDamage;
